// operationQueueSlice.ts
import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit'
import PQueue from 'p-queue'

// Create a queue with concurrency limit of 1
export const apiQueue = new PQueue({ concurrency: 1 })

// Define the state interface
interface OperationQueueState {
  pendingOperations: number;
  saving: boolean;
  savingError: string | null;
}

const initialState: OperationQueueState = {
  pendingOperations: 0,
  saving: false,
  savingError: null,
}

// Helper function to add operations to the queue with proper state management
export const queueOperation = createAsyncThunk(
  'vocabularyOperationQueue/queueOperation',
  async (operationFn: () => Promise<any>, { getState, dispatch }) => {
    dispatch(incrementPendingOperations())
    dispatch(setSaving(true))

    console.log('queueOperation', (getState() as any).vocabularyOperationQueue.pendingOperations)

    try {
      return await apiQueue.add(operationFn)
    } catch (error) {
      dispatch(setSavingError(error instanceof Error ? error.message : 'Unknown error'))
      throw error
    } finally {
      dispatch(setSaving(false))
      dispatch(decrementPendingOperations())
    }
  })

// Create the slice
export const operationQueueSlice = createSlice({
  name: 'operationQueue',
  initialState,
  reducers: {
    incrementPendingOperations: (state) => {
      state.pendingOperations += 1
    },
    decrementPendingOperations: (state) => {
      state.pendingOperations = Math.max(0, state.pendingOperations - 1)
    },
    setSaving: (state, action: PayloadAction<boolean>) => {
      state.saving = action.payload
      if (action.payload) {
        state.savingError = null
      }
    },
    setSavingError: (state, action: PayloadAction<string | null>) => {
      state.savingError = action.payload
      state.saving = false
    },
    resetQueue: (state) => {
      state.pendingOperations = 0
      state.saving = false
      state.savingError = null
    },
  },
})

// Export actions
export const {
  incrementPendingOperations,
  decrementPendingOperations,
  setSaving,
  setSavingError,
  resetQueue,
} = operationQueueSlice.actions

// Export reducer
export default operationQueueSlice.reducer